export {
    default as Icon,
    loader as IconLoader
} from './src/components/Icon';